export class SpotCheckKeyboardSelector {
	static readonly SPOT_CHECK_MODAL_SELECTOR = 'spot-check-modal';
	static readonly SPOT_CHECK_MODAL_TOGGLE_SELECTOR = '.br-spot-check > button';

	static readonly AFFECTED_WIDGETS_CONTAINER_SELECTOR = '.affected-widgets-container';
	static readonly COLLAPSING_PANEL_SELECTOR = 'collapsing-panel';
}
